import { apiClient } from "./client";

// Endpoint coord-facing: lista coordenadores ativos da coordenação.
// Requer caller seja Admin ou Coord vinculado à mesma coordenação.
export const listarCoordenadoresDaCoordenacao = (coordenacaoId) =>
  apiClient.get(`/coordenacoes/${coordenacaoId}/coordenadores`);
